import { apiFetch } from '../httpClient';

const PUSH_TOKEN_REGISTER_ENDPOINT =
  process.env.REACT_APP_PUSH_TOKEN_REGISTER_ENDPOINT || '/api/push-tokens';
const PUSH_TOKEN_UNREGISTER_ENDPOINT =
  process.env.REACT_APP_PUSH_TOKEN_UNREGISTER_ENDPOINT || '/api/push-tokens';
const PUSH_TOKEN_UNREGISTER_METHOD =
  process.env.REACT_APP_PUSH_TOKEN_UNREGISTER_METHOD || 'DELETE';

// 로그인 사용자 디바이스 푸시 토큰을 백엔드에 등록/업데이트한다.
export async function registerPushToken(payload) {
  const token = String(payload?.token || '').trim();
  if (!token) {
    throw new Error('푸시 토큰이 필요합니다.');
  }

  return apiFetch(PUSH_TOKEN_REGISTER_ENDPOINT, {
    method: 'POST',
    body: {
      token,
      platform: payload?.platform || 'unknown',
      appVersion: payload?.appVersion || null,
      settings: payload?.settings || null,
    },
  });
}

// 로그아웃 시 현재 디바이스 토큰 연결을 해제한다.
export async function unregisterPushToken(token) {
  const normalizedToken = String(token || '').trim();
  if (!normalizedToken) {
    return null;
  }

  return apiFetch(PUSH_TOKEN_UNREGISTER_ENDPOINT, {
    method: PUSH_TOKEN_UNREGISTER_METHOD,
    body: {
      token: normalizedToken,
    },
  });
}
